module.exports = __webpack_public_path__ + "media/images/health-partners-logo@2x-be77902485129acbe5fdc109d8bb0cf5.webp";